import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { getTheme } from "./Theme/theme";
import Router from "./routes/routes";
import { bindActionCreators } from "redux";
import { isMobile } from "./components/common/utils";
import { GA_REACT } from "./components/common/GA-React";

function App(props) {
  useEffect(() => {
    if (props.useGA) {
      GA_REACT.initialize();
      GA_REACT.storePageView();
      if (isMobile()) {
        GA_REACT.createEvent(GA_REACT.ACTION.MOBILE.OPEN);
        return;
      }
      GA_REACT.createEvent(GA_REACT.ACTION.DESKTOP.OPEN);
    }
  }, [props.useGA]);
  const [themeVar, setThemeVar] = React.useState("light");
  const [primaryMainColor, setPrimaryMainColor] = React.useState("#2badbc");
  const theme = React.useMemo(() => {
    return getTheme({
      type: themeVar,
      primary: primaryMainColor,
      secondary: "#f06292",
    });
  }, [themeVar, primaryMainColor]);

  const handleThemeToggle = () =>
    setThemeVar(themeVar === "light" ? "dark" : "light");

  const handlePrimaryColorChange = (color) => setPrimaryMainColor(color);
  return (
    <MuiThemeProvider theme={theme}>
      <Router
        themeType={themeVar}
        themeColor={primaryMainColor}
        handlePrimaryColorChange={handlePrimaryColorChange}
        handleThemeToggle={handleThemeToggle}
      />
    </MuiThemeProvider>
  );
}

const mapStateToProps = (state) => ({
  ...state.mainLayoutReducer,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // getInitialParam
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
